import primaryComponents from "../../../../primaryComponents";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { WaybillImage } from "../../../../../assets/svgImages";
import {
  DeleteIcon,
  EyeIcon,
  WaybillIcon,
} from "../../../../../assets/svgIcons";
import { useGetBankNameList } from "../../../../../hooks/api/queries";

export const AdditionalDetailsForm = ({
  billsForm,
  setBillsForm = () => {},
  handleUploadInvoice = () => {},
  ...validationParams
}) => {
  const { register, control } = validationParams;
  const { data: bankList } = useGetBankNameList({});

  return (
    <div className={`${globalStyles.cardWithBorder} white`}>
      <h4 className="mb-4 font-weight-normal">Additional Details</h4>

      <div className={"d-flex flex-column flex-md-row"} style={{ gap: "15px" }}>
        <div className={`w-100 ${globalStyles.cardWithBorder}`}>
          <h6 className="gray--text ">Bank Details</h6>
          <primaryComponents.InputField
            control={control}
            name={"account_name"}
            register={register}
            label="Account Name"
            placeholder={"Enter account name"}
            classNames="white"
            value={billsForm?.account_name}
            onChange={({ target: { value } }) => {
              setBillsForm((prev) => ({
                ...prev,
                account_name: value,
              }));
            }}
          />
          <primaryComponents.InputFieldV2
            control={control}
            name={"account_number"}
            register={register}
            label="Account Number"
            placeholder={"Enter account number"}
            classNames="white"
            value={billsForm?.account_number}
            onChange={({ target: { value } }) => {
              setBillsForm((prev) => ({
                ...prev,
                account_number: value,
              }));
            }}
          />

          <primaryComponents.SelectFieldV2
            control={control}
            label="Bank"
            placeholder="Select bank"
            name="bank"
            nameKey={"bank_name"}
            idKey={"bank_code"}
            options={bankList}
            value={billsForm?.bank_name || "Select bank"}
            onChange={(value, label) => {
              setBillsForm((prev) => ({
                ...prev,
                bank_name: label,
              }));
            }}
          />
        </div>

        <div className={`w-100 ${globalStyles.cardWithBorder} card-plain px-0`}>
          <div className="d-flex justify-content-between px-3">
            <div>
              <h6 className="mb-0">Invoice</h6>
              <p className="gray--text small-text-size">Upload image here</p>
            </div>

            <div>
              <primaryComponents.FileInput
                name="waybillReceipt"
                placeHolder={"Upload File"}
                coverStyle={{ width: "170px" }}
                floatError={false}
                truncateTextSize={15}
                showFileName={false}
                onChange={(document, fileName) => {
                  handleUploadInvoice(document, fileName);
                }}
              />
            </div>
          </div>

          {!billsForm?.invoice_urls?.length ? (
            <>
              <hr />
              <div className="text-center mt-3 px-3">
                <WaybillImage />
                <p>
                  No file uploaded
                  <br />
                  File uploaded will appear here
                </p>
              </div>
            </>
          ) : (
            <>
              {billsForm?.invoice_urls?.map((item, index) => (
                <div
                  key={index}
                  className={`${globalStyles.cardWithBorder} flex-row align-items-center justify-content-between white px-3 mb-2`}
                  style={{
                    borderRadius: 0,
                    borderRight: "none",
                    borderLeft: "none",
                  }}
                >
                  <span className="d-flex align-items-center">
                    <WaybillIcon className="mr-2" />
                    {item?.file_name || `Media ${index + 1}`}
                  </span>

                  <span className="d-flex">
                    <span
                      className="cursor-pointer d-flex align-items-center mr-2"
                      onClick={() => window.open(item?.url)}
                    >
                      <EyeIcon />
                      <span className="purple--text small-text-size ml-2">
                        View File
                      </span>
                    </span>

                    <span
                      className="cursor-pointer"
                      onClick={() => {
                        const newInvoiceUrls = [...billsForm?.invoice_urls];
                        newInvoiceUrls?.splice(index, 1);

                        setBillsForm((prev) => ({
                          ...prev,
                          invoice_urls: newInvoiceUrls,
                        }));
                      }}
                    >
                      <DeleteIcon />
                    </span>
                  </span>
                </div>
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
};
